import { InfoTooltip, Typography } from '@client/toolkit';
import { FaRegCircleQuestion } from 'react-icons/fa6';

import { MetricCard } from '../metric-card';

interface KpiTileProps {
  label: string;
  value: string;
  sub?: string;
  loading?: boolean;
  /** Optional calculation explanation shown in an info ("i") tooltip next to the label. */
  tooltip?: string;
  /** Optional content rendered below the value (and sub), e.g. a budget progress bar + legend. */
  footer?: React.ReactNode;
}

/** Single KPI box used across the portfolio reports: title, large value, optional sub-line. */
export function KpiTile({ label, value, sub, loading, tooltip, footer }: KpiTileProps) {
  return (
    <MetricCard
      title={label}
      isLoading={loading}
      titleAdornment={
        tooltip ? (
          <InfoTooltip message={tooltip} messageClassName="w-56 z-50" enterDelay="delay-100">
            <FaRegCircleQuestion className="text-gray-400 text-sm" />
          </InfoTooltip>
        ) : undefined
      }
    >
      <Typography variantFontSize="h2">{value}</Typography>
      {sub ? (
        <Typography variantFontSize="sub" className="text-white/60">
          {sub}
        </Typography>
      ) : null}
      {footer}
    </MetricCard>
  );
}
